module.exports = __webpack_public_path__ + "img/BoD_13_Mdm_Zuraidah_Abdullah.2c6def6e.jpg";